import { render, staticRenderFns } from "./IsracardCredsHelpPopup.vue?vue&type=template&id=1e71607a&scoped=true&"
import script from "./IsracardCredsHelpPopup.vue?vue&type=script&lang=js&"
export * from "./IsracardCredsHelpPopup.vue?vue&type=script&lang=js&"
import style0 from "./IsracardCredsHelpPopup.vue?vue&type=style&index=0&id=1e71607a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e71607a",
  null
  
)

export default component.exports